import { render } from "./SkillBodyEditor.vue?vue&type=template&id=2ed93a69&scoped=true"
import script from "./SkillBodyEditor.vue?vue&type=script&lang=js"
export * from "./SkillBodyEditor.vue?vue&type=script&lang=js"

import "./SkillBodyEditor.vue?vue&type=style&index=0&id=2ed93a69&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed93a69"]])

export default __exports__